"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardSize = void 0;
/**
 * 看板卡片大小
 */
var CardSize;
(function (CardSize) {
    CardSize["SMALL"] = "small";
    CardSize["MEDIUM"] = "medium";
    CardSize["LARGE"] = "large";
})(CardSize = exports.CardSize || (exports.CardSize = {}));
